import React, {useCallback, useEffect, useState} from 'react';
import './MultiSelectBlock.scss';
import {Button} from "../../../../modules/Button";
import {useTranslation} from "react-i18next";
import {CloseStrokeIcon, DeleteIcon} from "../../../../image";
import ConfirmationModal from "../../../../modules/Modals/СonfirmationModal/СonfirmationModal";
import Text from '../../../../modules/Text/Text';
import MultiChangeLinks from "../MultiChangeLinks/MultiChangeLinks";
import MultiChangeDepartament from "../MultiChangeDepartament/MultiChangeDepartament";
import {GetVideosService, MassActionsDeleteVideosService} from "../../../../redux/actions";
import {useDispatch, useSelector} from "react-redux";
import {FILTER_SORT_PAGE_TYPES, getValueFilters} from "../../../../modules/Filters/helpers";
import {getChains} from "../../../../redux/actions/chainsActions";
import {VIDEOS_CONSTS} from "../../../../redux/constants";
import {ApiStatus} from "../../../../utils/constants";

const MultiSelectBlock = ({selectedVideoIds, page, changeSelectedIds}) => {
    const {t} = useTranslation();
    const [isVisibleDeleteModal, setIsVisibleDeleteModal] = useState(false);
    const toggleIsVisibleDeleteModal = useCallback(()=>setIsVisibleDeleteModal(prevState => !prevState),[])
    const dispatch = useDispatch();
    const allFilters = useSelector(state => state.filtersOrSort);
    const allFiltersValue = getValueFilters(allFilters,FILTER_SORT_PAGE_TYPES.MANAGED_VIDEOS);

    const onConfirm = async () => {
        try{
            dispatch({
                type: VIDEOS_CONSTS.CHANGE_API_STATUS_GET_VIDEOS,
                payload: ApiStatus.LOADING
            })
            toggleIsVisibleDeleteModal();
            await dispatch(MassActionsDeleteVideosService({
                video_ids: selectedVideoIds
            }));
            await dispatch(GetVideosService({limit: 20, offset: (page - 1) * 20, manage: true, ...allFiltersValue}));
            changeSelectedIds([]);
            dispatch({
                type: VIDEOS_CONSTS.CHANGE_API_STATUS_GET_VIDEOS,
                payload: ApiStatus.SUCCESS
            })
        }catch (e){
            dispatch({
                type: VIDEOS_CONSTS.CHANGE_API_STATUS_GET_VIDEOS,
                payload: ApiStatus.ERROR
            })
            console.error(e)
        }
    };

    useEffect(()=>{
         dispatch(getChains())
    },[])

    return (
        <>
            <div className="multi-block">
                <div className="multi-block__selected" onClick={() => changeSelectedIds([])}>
                    <CloseStrokeIcon/>
                    <Text font="medium" size="f12">{selectedVideoIds.length} {t('selected').toLowerCase()}</Text>
                </div>
                <MultiChangeDepartament videoIds={selectedVideoIds} page={page} changeSelectedIds={changeSelectedIds}/>
                <MultiChangeLinks videoIds={selectedVideoIds} page={page} changeSelectedIds={changeSelectedIds}/>
                <Button
                    text={t('button_delete')}
                    onClick={()=>setIsVisibleDeleteModal(true)}
                    variant={'secondary'}
                    leftIcon={<DeleteIcon/>}
                    color={"red"}
                    size={'xss'}
                />
            </div>
            {isVisibleDeleteModal ?
                <ConfirmationModal
                    show={isVisibleDeleteModal}
                    onClose={toggleIsVisibleDeleteModal}
                    title={t('delete_select_video_title')}
                    description={
                    <span>
                        {`${t('selected')}: ${selectedVideoIds.length} ${t('records_text')}. `}
                        <Text font="bold" size="f16">{t('delete_select_video_desc')}</Text>
                    </span>}
                    cancelButton={
                        <Button
                            text={t('button_cancel')}
                            onClick={toggleIsVisibleDeleteModal}
                            variant={'secondary'}
                            size={'m'}
                        />
                    }
                    confirmButton={
                        <Button
                            text={t('delete_for_all')}
                            onClick={onConfirm}
                            variant={'secondary'}
                            leftIcon={<DeleteIcon/>}
                            color={"red"}
                            size={'m'}
                        />
                    }
                />
                : null}
            </>
    );
};

export default MultiSelectBlock;